// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import ProductClient from "@/api/product/product-client";
const productClient = new ProductClient();
export default {
  createProduct: async function (context, payload) {
    var result = await productClient.postAsync(
      {
        url: `${productClient.url}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updateProduct: async function (context, payload) {
    var result = await productClient.putAsync(
      {
        url: `${productClient.url}/${payload.id}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  deleteProduct: async function (context, payload) {
    var result = await productClient.deleteAsync(
      {
        url: `${productClient.url}/${payload.id}`,
        queries: { isSoft: true },
      },
      true
    );
    return result;
  },

  getProduct: async function (context, payload) {
    var result = await productClient.getAsync(
      {
        url: `${productClient.url}/${payload.id}/detail`,

      },
      true
    );
    if (result && result.data) {
      context.commit("updateProduct", result.data);
      return result.data;
    }
    return null;
  },

  getProducts: async function (context, payload) {
    var result = await productClient.getAsync(
      {
        url: `${productClient.url}/search`,
        queries: payload,
      },
      true
    );
    if (result && result.data) {
      context.commit("updateTotalPage", result.data);
      return result.data;
    }
    return null;
  },

  getProductList: async function (context, payload) {
    var result = await productClient.getAsync(
      {
        url: `${productClient.url}/search`,
        queries: payload,
      },
      true
    );
    if (result && result.data && result.data.rows) {
      context.commit("updateProducts", result.data.rows);
      return result.data.rows;
    }
    return null;
  },
};
